import Asset from "./asset";
import Tag from "./tag";

export interface Document {
  id?: number;
  name?: string;
  version?: string;
  companyId?: number;
  subcompanyId?: number;
  assetId?: number;
  asset?: Asset;
  documentCategoryId?: number;
  documentSubcategoryId?: number;
  documentType?: string;
  physicalCopyRequired?: boolean;
  expirationDate?: string;
  expirationNoticeDays?: number;
  expirationGraceDays?: number;
  expirationReminderRepeatDays?: number;
  filePath?: string;
  typeName?: string;
  barcode?: string;
  tags?: Tag[];
  fieldName1?: string | null;
  fieldValue1?: string | null;
  fieldName2?: string | null;
  fieldValue2?: string | null;
  fieldName3?: string | null;
  fieldValue3?: string | null;
  fieldName4?: string | null;
  fieldValue4?: string | null;
  fieldName5?: string | null;
  fieldValue5?: string | null;
  fieldName6?: string | null;
  fieldValue6?: string | null;
  fieldName7?: string | null;
  fieldValue7?: string | null;
  fieldName8?: string | null;
  fieldValue8?: string | null;
  fieldName9?: string | null;
  fieldValue9?: string | null;
  fieldName10?: string | null;
  fieldValue10?: string | null;
  //fields for copying from another asset
  alreadyCreated?: boolean;
  checked?: boolean;
}

export const newDocument = (): Document => {
  return {};
};

export default Document;
